var ReactNative = require('react-native');

module.exports = ReactNative.WebView;



// WEBPACK FOOTER //
// ./src/wrappers/WebView-wrapper.js